import { ReactElement, useMemo } from "react";
import { ValidGlobalSearchItemPersistedModel } from "../../Persistence/validation";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { TimeZone } from "client/DateAndTime/timezones";
import { SearchListItem } from "client/Features/Search/SearchListItem";
import { generateTrackingId } from "client/Misc/utils";
import { EventListItem } from "client/Features/Hub/Events/ListItem/EventListItem";
import { HubItemMediaPreviewViewModel } from "client/Api/Hub/common";
import { useEventNavigationHandler } from "client/Features/Layout/TitleBar/GlobalSearch/Navigation/useEventNavigationHandler";
import { convertHubMedia } from "../../Persistence/convertPersistedData";

export type EventItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.Event>;
	navigationIndex: number;
	onRemove: () => void;
	timezone: TimeZone;
};

export const EventItemView = (props: EventItemViewProps): ReactElement => {
	const {
		item,
		navigationIndex,
		onRemove,
		timezone
	} = props;

	const {
		id,
		title,
		author,
		category,
		media: persistedMedia,
		startDate
	} = item.event;

	const media = useMemo(
		(): HubItemMediaPreviewViewModel => convertHubMedia(persistedMedia),
		[persistedMedia]
	);

	const executeHandler: () => void = useEventNavigationHandler({
		id,
		recentlyOpenedItem: item
	});

	return (
		<SearchListItem
			onExecute={executeHandler}
			trackingId={generateTrackingId("event-item", `|${id}`)}
		>
			<EventListItem
				title={title}
				authorName={author?.name}
				categoryName={category?.name}
				media={media}
				startDate={startDate}
				timezone={timezone}
				trackingId={generateTrackingId("event-item-result-list-item", `|${id}`)}
				onRemove={onRemove}
				itemIndex={navigationIndex}
				tabIndex={-1}
				onExecute={executeHandler}
			/>
		</SearchListItem>
	);
};
EventItemView.displayName = "EventItemView";